























import { Component, Vue } from 'vue-property-decorator';
import NavigationTop from '@/components/navigation/NavigationTop.vue';
import NavigationSidebar from '@/components/navigation/NavigationSidebar.vue';

@Component({
    components: {
        NavigationTop,
        NavigationSidebar,
    },
})
export default class SidebarLayout extends Vue {

}

